import { render, staticRenderFns } from "./VCardForums.vue?vue&type=template&id=7479aef8&scoped=true"
import script from "./VCardForums.vue?vue&type=script&lang=js"
export * from "./VCardForums.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7479aef8",
  null
  
)

export default component.exports